import { Breadcrumb } from "~/models/breadcrumb";
import { Breadcrumbs } from "~/common/components/breadcrumbs/Breadcrumbs";
import { Logger } from "~/utils/logger";
const logger = new Logger("breadcrumbs", "info");

export function BreadcrumbsView({
  crumbs,
}: {
  crumbs: Breadcrumb[] | undefined;
}) {
  if (!crumbs) {
    logger.warn("BreadcrumbsView: no crumbs");
    return null;
  }
  return <Breadcrumbs crumbs={crumbs} />;
}
